export const makeChatApiEndpoints = (chatId = ":chatId") => {
  const endpoints = {
    getChats: () => "/chats",
    getUnreadSummary: () => "/chats/unread-summary",
    getChatByEntity: (type: "project" | "task", entityId: string) => `/chat/entity/${type}/${entityId}`,
    createChat: () => "/chat",
    chatItem: (id = "") => `/chat/${id || chatId}`,
    deleteChat: (id = "") => `${endpoints.chatItem(id)}`,
    updateChat: (id = "") => `${endpoints.chatItem(id)}`,
    getMessages: (id = "") => `${endpoints.chatItem(id)}/messages`,
    sendMessage: (id = "") => `${endpoints.chatItem(id)}/message`,
    updateMessage: (id = "", messageId: string) => `${endpoints.chatItem(id)}/message/${messageId}`,
    getPinnedMessages: (id = "") => `${endpoints.getMessages(id)}/pinned`,
    searchMessages: (id = "") => `${endpoints.getMessages(id)}/search`,
    getMessagePosition: (id = "", messageId: string) => `${endpoints.updateMessage(id, messageId)}/position`,
    setMessagePinned: (id = "", messageId: string) => `${endpoints.updateMessage(id, messageId)}/pinned`,
    setMessageDeleted: (id = "", messageId: string) => `${endpoints.updateMessage(id, messageId)}/deleted`,
    setMessageReaction: (id = "", messageId: string) => `${endpoints.chatItem(id)}/message/${messageId}/reaction`,
    markChatAsRead: (id = "") => `${endpoints.chatItem(id)}/read`,
    getChatReadStates: (id = "") => `${endpoints.chatItem(id)}/read-states`,
    getChatParticipants: (id = "") => `${endpoints.chatItem(id)}/participants`,
    muteChat: (id = "") => `${endpoints.chatItem(id)}/mute`,
  }

  return endpoints
}
